import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { ImageCropData, PopupData, Service } from 'webapp-types';
import { Theme } from 'webapp/enums/enums';

import CommonImageUploadDropComponent from 'webapp/components/common/image-upload/drop';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import ReportsViewerImageCtComponent from 'webapp/components/reports/viewer/image-ct';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

interface Args {
	model?: ReportSlideFragment | null;
	onChange: (imageUrl: string, imageOriginalUrl: string, imageCrop: ImageCropData | null) => void;
	onRemove?: () => void;
}

export default class ReportsEditorEditableImageComponent extends Component<Args> {
	@service('navigation') declare navigationService: Service.Navigation;

	get bgTheme() {
		return this.args.model?.slide?.bgTheme || Theme.LIGHT;
	}

	@action
	onImageAdd(blobUrl: string) {
		this.openImageUploadPopup(blobUrl);
	}

	@action
	editImage() {
		this.openImageUploadPopup();
	}

	private openImageUploadPopup(blobUrl = '') {
		const onFinish: PopupData.Common.ImageUpload['onFinish'] = (url, originalUrl, crop) => {
			this.args.onChange(url, originalUrl, crop);
		};
		const imageData = this.args.model?.value || {},
			existingUrl = imageData.imageOriginalUrl || imageData.imageUrl,
			crop = imageData.imageCrop || null;

		this.navigationService.openImageUploadPopup(onFinish, blobUrl, existingUrl, crop);
	}
	<template>
		<ReportsViewerImageCtComponent @model={{@model}} @onEdit={{this.editImage}}>
			<CommonImageUploadDropComponent
				@onImageAdd={{this.onImageAdd}}
				@theme={{this.bgTheme}}
			/>
			{{#if @onRemove}}
				<a role="button" class="remove" {{on "click" @onRemove}}>
					<CommonUiIconComponent @name="Close" @size="sm" />
				</a>
			{{/if}}
		</ReportsViewerImageCtComponent>
	</template>
}
